import React, { useState, useEffect } from 'react'
import translate from '../../reusable/translate'
import { bindActionCreators } from 'redux'
import { useDispatch } from 'react-redux'
import commitmentSlice from "../../../state/slices/commitmentSlice";
import Tooltip from "../tooltip/Tooltip";

const OperationDescription = ({ operation, title, maxLength, language, rows, tooltipTextKey, useLanguageOverride }) => {

    const dispatch = useDispatch()
    const { changeOperationDescription } = bindActionCreators(commitmentSlice.actions, dispatch)

    const  [charsLeft, setCharsLeft] = useState(maxLength)

    useEffect(() => {
        setCharsLeft(maxLength - operation['operationDescription_' + language].length)
    }, [language])

    const setText = (value) => {
        changeOperationDescription({operationId: operation.operationId, language: language, content: value})
    }
    const languageOverride = useLanguageOverride ? language : undefined;
    return(
        <div className="margin-top-bot">
            <div className="flex-row space-between">
                <div className="flex-row">
                    <p className="p">
                        {translate({ textKey: title, languageOverride: languageOverride })}
                    </p>
                    {tooltipTextKey && (
                        <Tooltip textKey={tooltipTextKey} languageOverride={languageOverride}/>
                    )}
                </div>
                <p className="p">{charsLeft} {translate({ textKey: 'sit.commitment.operations.charsLeft', languageOverride: languageOverride })}</p>
            </div>
            <textarea
                className="text-area"
                name={title}
                rows={rows || "1"}
                value={operation['operationDescription_' + language]}
                maxLength={maxLength}
                onChange={(e) => {
                    setText(e.target.value)
                    setCharsLeft(maxLength - e.target.value.length)}
                }
            />
        </div>
    )
}

export default OperationDescription


// WEBPACK FOOTER //
// ./src/components/materialCommitment/operation/OperationDescription.jsx